module Easypass {
    export class Entreprise {
        id: number;
        libelle: string;
        siteLibelle: string;
    }
}